import React, { useMemo } from 'react';
import { DataGrid } from 'ui-toolkit';
import { IVendorPayoffData } from '../../../types/vendorDashboard/IVendorPayoffs';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { PayoffsTableFormatters } from './PayoffsTableFormatters';

interface IPayoffsTableProps {
  payoffs: IVendorPayoffData[];
  loading: boolean;
}

export const PayoffsTable: React.FC<IPayoffsTableProps> = ({ payoffs, loading }) => {
  const columns: IBootstrapTableColumnProps<IVendorPayoffData>[] = useMemo(() => {
    return [
      {
        dataField: 'fileNumber',
        formatter: PayoffsTableFormatters.fileNumberFormatter,
        text: 'ID',
      },
      {
        dataField: 'borrowers',
        text: 'Borrower(s)',
      },
      {
        dataField: 'address',
        formatter: PayoffsTableFormatters.addressFormatter,
        text: 'Location',
      },
      {
        dataField: 'timeEnteredQueue',
        formatter: PayoffsTableFormatters.timeEnteredQueueFormatter,
        text: 'In Queue',
      },
      {
        dataField: 'eta',
        formatter: PayoffsTableFormatters.etaFormatter,
        text: 'ETA',
      },
      {
        dataField: 'status',
        formatter: PayoffsTableFormatters.statusFormatter,
        text: 'Status',
      },
    ];
  }, []);

  return (
    <DataGrid<IVendorPayoffData> columns={columns} keyField={'payoffRequestId'} data={payoffs} loading={loading} />
  );
};
